module.exports = __webpack_public_path__ + "static/media/ad.863ab3d5.webp";